import api from "./api";

export interface BillApprovalConfig {
  configId: string;
  userId: string;
  userName: string;
  email: string;
  approvalLevel: number;
}

export interface BillApprovalCompanyGroup {
  companyId: string;
  companyName: string;
  approvers: BillApprovalConfig[];
}

export const getBillApprovalConfigs = async (): Promise<{ message: string; data: BillApprovalCompanyGroup[] }> => {
  const response = await api.get("/bill-approvals");
  return response.data;
};

export const createBillApprovalConfig = async (
  companyId: string,
  approvers: { userId: string; approvalLevel: number }[]
): Promise<{ message: string; data: any }> => {
  const response = await api.post("/bill-approvals", { companyId, approvers });
  return response.data;
};

export const deleteBillApprovalConfig = async (id: string): Promise<{ message: string }> => {
  const response = await api.delete(`/bill-approvals/${id}`);
  return response.data;
};

export const deleteCompanyBillApprovalConfigs = async (companyId: string): Promise<{ message: string }> => {
  const response = await api.delete(`/bill-approvals/company/${companyId}`);
  return response.data;
};

export const checkIsApprover = async (companyId?: string): Promise<{ isApprover: boolean }> => {
  const response = await api.get("/bill-approvals/me/is-approver", { params: { companyId } });
  return response.data.data;
};

export const checkIsApproverforFinance = async (companyIds?: string[]): Promise<{ isApprover: boolean }> => {
  const response = await api.get("/bill-approvals/me/is-approver", { params: { companyId: companyIds } });
  return response.data.data;
};

export default {
  getBillApprovalConfigs,
  createBillApprovalConfig,
  deleteBillApprovalConfig,
  deleteCompanyBillApprovalConfigs,
  checkIsApprover,
};
